import React from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'

//Components
import Multiselector from './Multiselector'
import DownloadParentNode from './DownloadParentNode'
import DownloadChildNode from './DownloadChildNode'

//Styles
import styles from './DownloadContainer.module.scss'

//Types
import { DownloadTOC, DownloadParentNode as ParentNodeType, DownloadChildNode as ChildNodeType } from 'types/download'

//Util
import {selectAll, unselectAll } from 'util/toc'

interface Props {
  tocInfo?: DownloadTOC,
  title?: string,
  setToc: (toc?: DownloadTOC) => void
}

const DownloadFileSelector = ({
  tocInfo,
  title,
  setToc
}:Props) => {

  const { t } = useTranslation()

  const selectAllNodes = () => {
    selectAll(tocInfo?.toc || [])
    handleChange()
  }

  const unselectAllNodes = () => {
    unselectAll(tocInfo?.toc || [])
    handleChange()
  }

  const handleChange = () => {
    setToc(tocInfo)
  }

  return (
    <>
      <Multiselector selectAll={selectAllNodes} unselectAll={unselectAllNodes}/>
      <div className={styles.fileSelector}>
        {
          tocInfo && tocInfo.toc.length > 0 ?
          <ul>
            {
              tocInfo.toc.map((node)=> {
                let item
                if (node.type === 'parent') {
                  let tocNode = node as ParentNodeType
                  item = <DownloadParentNode node={tocNode} key={tocNode.title} handleChange={handleChange}/>
                } else if (node.type === 'include') {
                  let tocNode = node as ChildNodeType
                  item = <DownloadChildNode node={tocNode} key={`${tocNode.alias}_${tocNode.version}`} handleChange={handleChange}/>
                } else {
                  item = null
                }
                return item
              })
            }
          </ul>
          :
          <h3>{title ? t("helpcenter-gui-icu.downloadpage.fileselector.no_toc.msg", {title:title}) : t("helpcenter-gui-icu.downloadpage.fileselector.not_found.msg")}</h3>
        }
      </div>
    </>
  )
}
export default DownloadFileSelector